import { Dispatch, SetStateAction } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Modal, List, ListItem, Avatar, ListItemAvatar, ListItemText, } from '@mui/material'
import { useNavigate } from 'react-router-dom';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>
    userIds: string[];
    usersList: { id: string; label: string, avatar: string }[];
}

export default function UsersList({ open, onClose, setOpen, userIds, usersList }: ModalProps) {

    const navigate = useNavigate();
    const selectedUsers = usersList.filter((user) => userIds.includes(user.id));

    return (
        <Modal
            className="modal usersList_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog sm">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Users List</h2>
                        <div className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </div>
                    </div>
                    <List className="user_list">
                        {selectedUsers.map((user) => (
                            <ListItem key={user.id} onClick={() => navigate("/manage-users/detail")}>
                                <ListItemAvatar>
                                    <Avatar alt={user.label} src={user.avatar} />
                                </ListItemAvatar>
                                <ListItemText primary={user.label} />
                            </ListItem>
                        ))}
                    </List>
                </div>
            </div>
        </Modal >
    )
}
